import { initializeApp } from 'firebase/app'
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth'
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager, enableNetwork, disableNetwork } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const configFromEnv = {
	apiKey: process.env.REACT_APP_MED_API_KEY,
	authDomain: process.env.REACT_APP_MED_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_MED_PROJECT_ID,
	storageBucket: process.env.REACT_APP_MED_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_MED_SENDER_ID,
	appId: process.env.REACT_APP_MED_APP_ID,
	measurementId: process.env.REACT_APP_MED_MEASUREMENT_ID || 'G-03RM55Q2HQ'
}

const requiredKeys = [
	'REACT_APP_MED_API_KEY',
	'REACT_APP_MED_AUTH_DOMAIN',
	'REACT_APP_MED_PROJECT_ID',
	'REACT_APP_MED_STORAGE_BUCKET',
	'REACT_APP_MED_SENDER_ID',
	'REACT_APP_MED_APP_ID'
]

const missing = requiredKeys.filter((k) => !process.env[k])
if (missing.length > 0) {
	// Helpful error in dev to guide setup
	// eslint-disable-next-line no-console
	console.error(
		`Missing Firebase environment variables: ${missing.join(
			', '
		)}.\nCreate a .env.local file in the project root based on .env.example and restart the dev server.`
	)
}

const app = initializeApp(configFromEnv)

// Firestore v10+ offline persistence (replaces deprecated enableIndexedDbPersistence)
const firestore = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
})

const auth = getAuth(app)
const storage = getStorage(app)

const isDev = process.env.NODE_ENV === 'development'

if (isDev) {
  console.log('🔧 Firestore initialized with persistent local cache (multi-tab)')
}

// Set auth persistence
setPersistence(auth, browserLocalPersistence)

// Add connection monitoring
window.addEventListener('online', () => {
  if (isDev) {
    console.log('🌐 Network online - enabling Firestore')
  }
  enableNetwork(firestore).catch((err) => {
    if (isDev) {
      console.error(err)
    }
  })
})

window.addEventListener('offline', () => {
  if (isDev) {
    console.log('📴 Network offline - disabling Firestore')
  }
  disableNetwork(firestore).catch((err) => {
    if (isDev) {
      console.error(err)
    }
  })
})

export { auth, app, firestore, configFromEnv as firebaseConfig, storage }
